const GlobalStyle = `
:root {
  direction: rtl;
  font-family: var(--alomni);

}
`;

export default GlobalStyle;
